<template>
    <div>
        <h3 class="text-center mb-3">Editar Estudiante</h3>
        <b-row class="my-3">
            <b-col cols="6" md="9">
                <b-button
                    variant="info"
                    class="mx-2"
                    :to="{ name: 'admin-students-list' }"
                >
                    <b-icon-arrow-bar-left /> Atrás
                </b-button>
            </b-col>
            <b-col cols="6" md="3">
                <b-button
                    variant="warning"
                    class="float-right mx-2"
                    :to="{ name: 'admin-students-edit-password'}"
                >
                    <b-icon-exclamation-triangle /> Editar Contraseña
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-form @submit.stop.prevent="onSubmit">
                    <b-form-group
                        id="input-group-id-card-number"
                        label="*Cédula de Identidad:"
                        label-for="input-id-card-number"
                    >
                        <b-form-input
                            id="input-id-card-number"
                            v-model="$v.form.idCardNumber.$model"
                            type="text"
                            required
                            :disabled="formDisabled"
                            :state="validateState('idCardNumber')"
                        />
                        <b-form-invalid-feedback id="input-id-card-number-feedback">
                            <ul>
                                <li v-if="!$v.form.idCardNumber.required">Este campo es requerido.</li>
                                <li v-if="!$v.form.idCardNumber.numeric">Solo se permiten números positivos.</li>
                                <li v-if="!$v.form.idCardNumber.minLength">El número debe tener más de 3 cifras.</li>
                                <li v-if="!$v.form.idCardNumber.isUnique">Ya existe un usuario con este número de cédula.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        id="input-group-name"
                        label="*Nombres:"
                        label-for="input-name"
                    >
                        <b-form-input
                            id="input-name"
                            v-model="$v.form.name.$model"
                            type="text"
                            required
                            :disabled="formDisabled"
                            :state="validateState('name')"
                        />
                        <b-form-invalid-feedback id="input-name-feedback">
                            <ul>
                                <li v-if="!$v.form.name.required">Este campo es requerido.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        id="input-group-last-name"
                        label="*Apellidos:"
                        label-for="input-last-name"
                    >
                        <b-form-input
                            id="input-last-name"
                            v-model="$v.form.lastName.$model"
                            type="text"
                            required
                            :disabled="formDisabled"
                            :state="validateState('lastName')"
                        />
                        <b-form-invalid-feedback id="input-last-name-feedback">
                            <ul>
                                <li v-if="!$v.form.lastName.required">Este campo es requerido.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group
                        id="input-group-email"
                        label="*Correo Electrónico:"
                        label-for="input-email"
                    >
                        <b-form-input
                            id="input-email"
                            v-model="$v.form.email.$model"
                            type="email"
                            required
                            :disabled="formDisabled"
                            :state="validateState('email')"
                        />
                        <b-form-invalid-feedback id="input-email-feedback">
                            <ul>
                                <li v-if="!$v.form.email.required">Este campo es requerido.</li>
                                <li v-if="!$v.form.email.email">Este campo debe ser una dirección de correo válida.</li>
                            </ul>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <div class="text-center pt-4">
                        <b-button
                            type="submit"
                            variant="primary"
                            size="lg"
                            :disabled="formDisabled || $v.form.$invalid"
                        >
                            Editar
                        </b-button>
                    </div>
                </b-form>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { required, minLength, numeric, email } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'AdminStudentsEditForm',
    data () {
        return {
            formDisabled: false,
            form: {
                idCardNumber: '',
                oldIdCardNumber: '',
                name: '',
                lastName: '',
                email: ''
            }
        }
    },
    validations: {
        form: {
            idCardNumber: {
                required,
                numeric,
                minLength: minLength(4),
                isUnique: async function (val) {
                    if (val === '' || val.length < 4) return true
                    try {
                        const res = await this.readUserByIdCardNumber(val)
                        // This check avoids comparing the current idCardNumber code with its own.
                        if (res.data.identity_card === this.form.oldIdCardNumber) {
                            return true
                        }
                        return false
                    } catch (err) {
                        if (err.response && err.response.status === 404) {
                            return true
                        } else {
                            this.$root.unknownErrorToast()
                            return false
                        }
                    }
                }
            },
            name: {
                required
            },
            lastName: {
                required
            },
            email: {
                required,
                email
            }
        }
    },
    watch: {
        async '$route' (to, from) {
            await this.loadStudentbyIdCardNumber(to.params.studentIdCardNumber)
        }
    },
    computed: {
        ...mapState([
            'adminSelectedStudent'
        ])
    },
    methods: {
        ...mapActions([
            'readUserByIdCardNumber',
            'editStudent',
            'readAllAdminStudents'
        ]),
        // TODO: Refactor this method into a ValidatedFormMixin
        validateState (name) {
            const { $dirty, $error } = this.$v.form[name]
            return $dirty ? !$error : null
        },
        async loadStudentbyIdCardNumber (studentIdCardNumber) {
            let loader = null
            try {
                loader = this.$root.$loading.show()
                var res = await this.readUserByIdCardNumber(studentIdCardNumber)
                // Create a copy
                var student = JSON.parse(JSON.stringify(res.data))

                this.form.idCardNumber = student.identity_card
                this.form.oldIdCardNumber = student.identity_card
                this.form.name = student.name
                this.form.lastName = student.lastname
                this.form.email = student.email
            } catch (err) {
                console.log(err)
                if (err.response && err.response.status === 404) {
                    this.$root.dangerToast(`No existe un estudiante con el número de cédula ${studentIdCardNumber}`)
                    this.$router.replace({ name: 'admin-students-list' })
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                loader.hide()
            }
        },
        async onSubmit () {
            let loader = null
            // Create a const copy
            const payloadData = JSON.parse(JSON.stringify(this.form))
            try {
                this.formDisabled = true
                loader = this.$root.$loading.show()
                await this.editStudent(payloadData)
                await this.readAllAdminStudents()
                this.$root.successToast(`El estudiante ha sido editado exitosamente.`)
                this.$router.replace({ name: 'admin-students-list' })
            } catch (err) {
                console.log({ err: err })
                if (err.response && (err.response.status === 404 || err.response.status === 400)) {
                    this.$root.dangerToast('Datos incorrectos, vuelva a intentar.')
                } else {
                    this.$root.unknownErrorToast()
                }
            } finally {
                this.formDisabled = false
                loader.hide()
            }
        }
    },
    async beforeMount () {
        await this.loadStudentbyIdCardNumber(this.$route.params.studentIdCardNumber)
    }
}
</script>
